export class BuildingTypeModel
{
	id: number = undefined;
	name: string = undefined;
	type: string = undefined;
	datasheetmodel: string = undefined;


	constructor(values: Object) {
		if(values != undefined) this.exchange(values);
	}
	exchange(values: Object = {}) {
	    for (let p in values) {
		    if (this.hasOwnProperty(p) && values.hasOwnProperty(p)) {
		    	if(p == 'id' && this.id != undefined) {
		    		continue;
		    	}
		    	else {
		    		this[p] = values[p];
		    	} 
		    }
		  }
	}


	toString()
	{
		return "buildingType.model "+this.name;
	}
}